import { Table } from 'antd';
export default function DataTable({
  header,
  dataSource,
  pagination,
  scroll,
  loading,
  rowClassName = null,
}) {
  const tableScroll = scroll ? { y: scroll, ...scroll } : {};
  return (
    <div className="overflow-x-auto">
      <Table
        size="small"
        dataSource={dataSource}
        columns={header}
        pagination={pagination}
        loading={loading || !dataSource}
        scroll={tableScroll}
        rowClassName={rowClassName}
      />
    </div>
  );
}
